jQuery(function ($) {
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 100) {
      $("header").addClass("headerBG");
    } else {
      $("header").removeClass("headerBG");
    }
  });
});
// JS FOR COOKIE BOX
function CookieBoxFx() {
    document.querySelectorAll(".shopify-pc__prefs__options input").forEach(function(i){i.click()})
  document.querySelectorAll(".shopify-pc__prefs__options input").forEach(function(i){i.disabled = true})
  // document.querySelectorAll(".shopify-pc__prefs__options input").forEach(function(i){console.log(i.checked)})
} 
document.addEventListener('click', function(e) {
    if (e.target.closest('#shopify-pc__banner__btn-manage-prefs')) {
        // console.log('Prefs button clicked! Running CookieBoxFx().');
        CookieBoxFx();
    }
}); 

/* ============================================================
   REMOVED 2026-07-08 — applyTradeDiscountMessage()

   This appended <p class="cs-subtotal-dc">Trade Discount: $X</p> beside the cart
   subtotal, where X = parse('.cs-totalcart-hidden span') - parse('.cs-cartDcP span').
   Both selectors resolved to the same figure (Shopify's cart total), so it printed
   "Trade Discount: $0.00". It had been invisible only because a CSS rule elsewhere
   hid .cs-subtotal-dc.

   The trade discount is now rendered from Liquid in templates/cart.ajax.liquid,
   split out from code discounts by the discount's own title.
   ============================================================ */

/* ============================================================
   REMOVED 2026-07-08 — the trade_total_cents fetch/XHR patch (added 2026-06-29).

   It intercepted every outgoing request carrying items_json and appended
   trade_total_cents, scraped from document.querySelector('.cs-cartDcP span').

   Its premise was: "BSS shows trade pricing only in the DOM; Shopify's cart object
   stays at retail." That stopped being true on 2026-07-07, when trade pricing moved
   to native Shopify automatic discounts ("Trade 20% - All Other Products",
   "Trade 15% - Natural Stone", "Trade 50% - Samples"). cart.total_price now carries
   the trade price on its own, so the gateway no longer needs to be told separately.

   It was also fragile: querySelector returns the FIRST .cs-cartDcP in the document,
   and which element that is depended on cart markup that has since been rewritten.

   VERIFY BEFORE PUBLISHING: confirm the Make -> Stripe gateway derives its charge from
   the Shopify cart / draft order rather than from trade_total_cents. If the gateway
   still reads that field, restore this block from git history or from the
   "EB — Trade Checkout Fix — publish me" theme before going live.
   ============================================================ */

//  Heading Js

document.addEventListener("DOMContentLoaded", function () {
  const validTitles = [
    "Curated Material Selection at Elemento Bath",
    "Wishlist – Elemento Bath"
  ];

  if (validTitles.includes(document.title)) {
    const h1 = document.createElement("h1");
    h1.className = "cs-hidden-hd";
    h1.textContent = ""; 
    document.body.append(h1); 
  }
});
// ADD DISCLAIMER
(function watchForForm() {
  const interval = 300; // check every 300ms
  const maxAttempts = 50; // about 15 seconds total
  let attempts = 0;

  const intervalId = setInterval(() => {
    const formElement = document.getElementById("chRegForm");

    if (formElement) {
      console.log(formElement, "loaded");

      // Prevent adding duplicate disclaimer
      if (!formElement.querySelector('.cs-form-disclaimer')) {
        const disclaimerForm = document.createElement("p");
        disclaimerForm.className = "cs-form-disclaimer";
        disclaimerForm.innerHTML =
          "By joining you agree to our <a href='https://elementobath.com/policies/terms-of-service'>Terms of Service</a> and to<br> receive our email newsletter.";

        formElement.appendChild(disclaimerForm);
      }

      clearInterval(intervalId); // stop checking once added
    }

    attempts++;
    if (attempts >= maxAttempts) {
      clearInterval(intervalId);
      console.warn("Timeout: #chRegForm not found.");
    }
  }, interval);
})();

// BESPODE ACCORDIAN UPDATED

$(document).ready(function () {
  $('[id^="tab-button"]').off('click').on('click', function (e) {
    // Only run logic if this is actually a tab button click
    var contentId = $(this).attr('aria-controls');
    var content = $('#' + contentId);
    var isActive = $(this).attr('aria-selected') === 'true';

    // Close all accordions first
    $('[id^="tab-button"]').removeClass('active').attr('aria-selected', 'false');
    $('[id^="tab-content"]').slideUp();

    if (!isActive) {
      // If not active, open the clicked accordion
      $(this).addClass('active').attr('aria-selected', 'true');
      content.slideDown();
    }

    // Instead of e.preventDefault(), just return false to prevent link jump
    return false;
  });
});

// OUR PRODUCTS
$(function() {
    $('.scroll-down').click(function() { 
        var scrollDistance;
        if ($(window).width() < 768) {
            // For mobile devices
            scrollDistance = 650; // Adjust this value as needed
        } else if ($(window).width() > 1920) {
            // For large desktop devices
            scrollDistance = 1280; // Adjust this value as neededs
        } else {
            // For desktop devices
            scrollDistance = 800; // Adjust this value as needed
        }
        $('html, body').animate({
            scrollTop: '+=' + scrollDistance
        }, 500, 'linear');
        return false;
    });
});



// COLLECTION SECTION — Hero "DISCOVER" button smooth-scrolls to the next section (the second
// fold / category grid). Robust: finds the section the button lives in and scrolls to whatever
// section follows it. Lands the grid flush at the very top (no header offset) so none of the hero
// shows above it — the sticky header floats over the grid's top edge. No hard-coded IDs or pixels.
$(function () {
    $(document).on('click', 'a.hero__btn, a.btn.hero__btn', function (e) {
        var hero = this.closest('.shopify-section');
        if (!hero) return;
        var next = hero.nextElementSibling;
        while (next && (next.offsetParent === null || next.offsetHeight < 5)) {
            next = next.nextElementSibling;
        }
        if (!next) return;
        e.preventDefault();
        var y = next.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop);
        window.scrollTo({ top: y, behavior: 'smooth' });
        return false;
    });
});

// BESPOKE banner
$(function() { 
    $('div#section-template--17074373296325__7c83026b-cf06-48ea-a5fc-ed1335e45abf .scroll-down').click(function() { 
        var scrollDistance;
        if ($(window).width() < 768) {
            // For mobile devices
            scrollDistance = 60; // Adjust this value as needed
        } else if ($(window).width() > 1920) {
            // For large desktop devices
            scrollDistance = 30; // Adjust this value as neededs
        }  else {
            // For desktop devices
            scrollDistance = 30; // Adjust this value as needed
        }
        $('html, body').animate({
            scrollTop: '+=' + scrollDistance
        }, 500, 'linear');
        return false;
    });
});


// PRODUCT PAGE DESCRIPTION TABS

 const tabs = document.querySelectorAll('.tabs li');
  const tabContents = document.querySelectorAll('.tabscontent');

  // Add click event listener to each tab
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      // Hide all tab contents
      tabContents.forEach(content => {
        content.style.display = 'none';
      });
      // Show the clicked tab content
      tabContents[index].style.display = 'block';
    });
  });


// concept collection form


let cardIDs = [];
let totalCollections = 50;
for (let i = 1; i <= totalCollections; i++) {
  let id = 'collection-' + String(i).padStart(3, '0'); // pads the number with leading zeros
  cardIDs.push(id);
}
let cards = document.querySelector('body'); // Select the body element
if (cardIDs.includes(cards.getAttribute('id'))) {
  let quoteForm = document.querySelector('div#quoteform');
  
      if (quoteForm) {
    document.querySelector('div#quoteform').style.display = 'block'; // Show the form
    document.querySelector('div#shopify-section-template--17074372935877__custom_tab_DaWdnz').style.display = 'none';
    document.querySelector('div#concptbrowse').style.display = 'block';
    document.querySelector('#noprodbtntxt').style.display = 'none';
      }
      
      } else {
        let quoteForm = document.querySelector('div#quoteform');
  
      if (quoteForm) {
      document.querySelector('div#quoteform').style.display = 'none'; // Hide the form
      document.querySelector('div#shopify-section-template--17074372935877__custom_tab_DaWdnz').style.display = 'block';
      document.querySelector('div#concptbrowse').style.display = 'none';
      document.querySelector('#noprodbtntxt').style.display = 'block';
      }
  }




  // WISH LIST JS 
document.addEventListener('DOMContentLoaded', function() {
  // Function to add item to wishlist
  function addToWishlist(item) {
    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
    wishlist.push(item);
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
    alert('Added to wishlist!');
  }

  // Function to remove item from wishlist
  function removeFromWishlist(variantId) {
    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
    wishlist = wishlist.filter(item => item.variantId !== variantId);
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
  }

  // Event listener for adding to wishlist
  document.querySelectorAll('.wl-add').forEach(button => {
    button.addEventListener('click', function() {
      const productHandle = this.getAttribute('data-product-handle');
      const variantId = this.getAttribute('data-variant-id');
      const item = {
        productHandle: productHandle,
        variantId: variantId
      };
      addToWishlist(item);
    });
  });

  // Event listener for removing from wishlist
  document.querySelectorAll('.wl-remove').forEach(button => {
    button.addEventListener('click', function() {
      const variantId = this.getAttribute('data-variant-id');
      removeFromWishlist(variantId);
    });
  });

  // Update the data-variant-id attribute when a variant is selected
  document.querySelectorAll('.variant-select').forEach(select => {
    select.addEventListener('change', function() {
      const selectedVariantId = this.value;
      const wishlistButton = this.closest('.dbtfy-wish_list').querySelector('.wl-add');
      wishlistButton.setAttribute('data-variant-id', selectedVariantId);
    });
  });
});
